import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-acupuncture',
  templateUrl: './acupuncture.component.html',
  styleUrls: ['./acupuncture.component.scss']
})
export class AcupunctureComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  btnBackClick = function () {
    this.router.navigateByUrl('/treatments')
  }
}
